var Marionette = require('backbone.marionette');
var YesNoConfirmationModal = require('../common/yes-no-confirmation-modal');

var Dicts = require('../../data/dicts');
var CommonUtils = require('../../utils/common-utils.js');

var utils = new CommonUtils();

var ContactsRowView = Marionette.View.extend({
    tagName: 'tr',
    className: 'contact-row clickable',
    template: require('../../templates/contacts/contacts-row.html'),

    ui: {
        td: 'td'
    },

    events: {
        'click #contact-delete': 'removeContact',
        'click #contact-edit': 'editContact',
        'click #preferred': 'onCheckPreferred',
        'click @ui.td': 'onRowSelected'
    },

    contactHovered: false,

    templateContext: function () {
        var that = this;
        var dateFrom = that.model.get('from');
        var dateTo = that.model.get('to');
        return {
            contactHovered: that.contactHovered,
            clearedReceiver: function () {
                var data = that.model.get('data') || "";
                data = data.replace(new RegExp(' ', 'g'), '');
                data = data.replace(new RegExp('_', 'g'), '');
                data = data.replace(new RegExp('-', 'g'), '');
                data = data.replace(new RegExp('\\(', 'g'), '');
                data = data.replace(new RegExp('\\)', 'g'), '');
                data = data.replace(new RegExp('\\+', 'g'), '');
                return data;
            },
            priority: utils.getContactPriorities()[that.model.get('priority')] || '',
            usage: Dicts.addressUsages[that.model.get('usage')] || '',
            dateFrom: dateFrom != undefined && dateFrom != '' && !isNaN(dateFrom) ? utils.longToDateTimeFormatted(dateFrom, 'MM/DD/YYYY') : '',
            dateTo: dateTo != undefined && dateTo != '' && !isNaN(dateTo) ? utils.longToDateTimeFormatted(dateTo, 'MM/DD/YYYY') : '',
            typeRepresentation: function (type) {
                return utils.getContactTypes()[type];
            },
            canEdit: that.getOption('canEdit'),
            simpleView: that.getOption('simpleView')
        }
    },

    initialize: function (options) {
        _.bindAll(this, 'removeContact', 'editContact', 'onCheckPreferred', 'onRowSelected');
    },

    removeContact: function (event) {
        this.triggerMethod('delete:model', this.model);
    },

    editContact: function (event) {
        this.triggerMethod('update:model', this.model);
    },

    onCheckPreferred: function (event) {
        this.model.set('preferred', event.target.checked);
        this.triggerMethod('update:model:wo:confirm', this.model);
    },

    onRowSelected: function () {
        var that = this;
        this.contactHovered = !this.contactHovered;
        this.triggerMethod('contact:hover', {
            hovered: this.contactHovered,
            addresses: that.model.get('addresses'),
            representatives: that.model.get('representatives')
        });

    }
});

var EmptyView = Marionette.View.extend({
    tagName: 'tr',
    template: _.template(_.reduce(_.map(_.range(5), function (value) {
        return '<td>-</td>'
    }), function (memo, str) {
        return memo + str;
    }, ""))
});

var ContactsTableBody = Marionette.CollectionView.extend({
    tagName: 'tbody',
    childView: ContactsRowView,
    emptyView: EmptyView,

    childViewEvents: {
        'update:model': 'updateModel',
        'update:model:wo:confirm': 'updateModelWoConfirm',
        'delete:model': 'deleteModel',
        'contact:hover': 'contactHover'
    },

    childViewOptions: function () {
        var that = this;
        return {
            canEdit: that.getOption('canEdit'),
            simpleView: that.getOption('simpleView') || false
        }
    },

    initialize: function (options) {
        _.bindAll(this, 'updateModel', 'deleteModel', 'updateModelWoConfirm', 'contactHover');
        this.collection = options.collection;
    },

    updateModel: function (model) {
        var callback = function () {
            this.triggerMethod('on:contact:action', {mode: 'edit', data: model});
        };
        this.triggerMethod('on:action', {
            callback: callback,
            mode: 'edit'
        });
    },

    updateModelWoConfirm: function (model) {
        this.triggerMethod('update:model:wo:confirm', model);
    },

    deleteModel: function (model) {
        var callback = function () {
            this.triggerMethod('on:contact:action', {mode: 'delete', data: model});
        };
        this.triggerMethod('on:action', {
            callback: callback,
            mode: 'delete'
        });
    },

    contactHover: function (hovered) {
        this.triggerMethod('contact:hover', hovered);
    }
});

var ContactsTableView = Marionette.View.extend({
    tagName: 'div',
    className: 'contacts-table',
    template: require('../../templates/contacts/contacts-table.html'),

    regions: {
        body: {
            el: 'tbody',
            replaceElement: true
        },
        confirmationModal: '#yes-no-confirmation-modal'
    },

    childViewEvents: {
        'action:confirmed': 'saveConfirmed',
        'update:model:wo:confirm': 'updateModelWoConfirm',
        'on:action': 'onAction',
        'contact:hover': 'contactHover'
    },

    ui: {
        addBtn: '#add-contact',
        addAddressBtn: '#add-address'
    },

    events: {
        'click @ui.addBtn': 'addNewContact',
        'click @ui.addAddressBtn': 'addNewAddress'
    },

    callback: undefined,

    templateContext: function () {
        return {
            canEdit: this.canEdit,
            simpleView: this.simpleView || false
        }
    },

    onRender: function () {
        this.showChildView('body', new ContactsTableBody({
            collection: this.collection,
            canEdit: this.canEdit,
            simpleView: this.simpleView
        }));
    },

    initialize: function (options) {
        _.bindAll(this, 'saveConfirmed', 'onAction', 'addNewContact', 'addNewAddress', 'updateModelWoConfirm', 'contactHover');
        this.collection = options.collection;
        this.canEdit = options.canEdit;
        this.simpleView = options.simpleView || false;
        this.actionsWoConfirmation = options.actionsWoConfirmation;
    },

    renderConfirmationModal: function (mode) {
        this.confirmationalModal = new YesNoConfirmationModal({message: 'You are going to ' + mode + ' contact. Are you sure?'});
        this.showChildView('confirmationModal', this.confirmationalModal);
        this.confirmationalModal.show();
    },

    onAction: function (data) {
        this.callback = data.callback;
        if (typeof this.callback !== "function")
            return;
        if (this.actionsWoConfirmation) {
            this.callback();
        } else
            this.renderConfirmationModal(data.mode);
    },

    saveConfirmed: function (data) {
        if (data.result == true) {
            this.callback();
        }
        else {
            this.confirmationalModal.hide();
        }
    },

    addNewContact: function () {
        this.triggerMethod('on:contact:action', {mode: 'add', data: ''});
    },

    addNewAddress: function () {
        this.triggerMethod('on:address:action', {mode: 'add', data: ''});
    },

    updateModelWoConfirm: function (model) {
        this.triggerMethod('on:contact:action', {mode: 'save', data: model});
    },

    contactHover: function (hovered) {
        this.triggerMethod('contact:hover', hovered);
    },

    add: function (model) {
        this.collection.add(model);
    }
});

module.exports = ContactsTableView;


//////////////////
// WEBPACK FOOTER
// ./app/views/contacts/contacts-table-view.js
// module id = 250
// module chunks = 0